import { CubeBuilder, NOOP_VOID, Place } from 'wdc-cube'

import { Places } from './Constants'
import { AccessAuditPresenter } from './modules/admin/access-audit'
import { BillingPresenter } from './modules/admin/billing'
import { ConfigurationPresenter } from './modules/admin/configurations'
import { OverviewPresenter } from './modules/overview'
import { MercadoVetPresenter, MvFilterCatalogFormPresenter, MvFilterCatalogSharePresenter } from './modules/mercado-vet'
import {
    AdFilterCatalogFormPresenter,
    AdFilterCatalogSharePresenter,
    AnaliseDesempenhoPresenter
} from './modules/analise-desempenho'
import { GroupManagerPresenter } from './modules/admin/group-manager'
import { GroupManagerFormPresenter } from './modules/admin/group-manager/form'
import { UserManagerPresenter } from './modules/admin/user-manager'
import { UserManagerFormPresenter } from './modules/admin/user-manager/form'
import { UserChangePasswordFormPresenter } from './modules/admin/user-manager/form/change-password'
import { GroupProfilePresenter } from './modules/group-profile'
import { AnalisePresenter } from './modules/motor-credito/analise'
import { AnaliseFormPresenter } from './modules/motor-credito/analise/form'
import { RegraFormPresenter } from './modules/motor-credito/analise/regra'
import { CondicaoFormPresenter } from './modules/motor-credito/analise/regra/condicao'
import { AnaliseSelectPresenter } from './modules/motor-credito/analise/select'
import { BorderoPresenter } from './modules/motor-credito/bordero'
import BorderoFormPresenter from './modules/motor-credito/bordero/form/bordero_form.presenter'
import { ResultadoAnalisePresenter } from './modules/motor-credito/bordero/resultado'
import { DialogoResultadoPresenter } from './modules/motor-credito/bordero/resultado-detalhado/dialogo-resultado'
import ResultadoDetalhadoAnalisePresenter from './modules/motor-credito/bordero/resultado-detalhado/resultado_detalhado_analise.presenter'
import StatusProcessamentoPresenter from './modules/motor-credito/bordero/status-processamento/status_processamento.presenter'
import { GrupoPresenter } from './modules/motor-credito/grupo'
import { GrupoFormPresenter } from './modules/motor-credito/grupo/form'
import { IntegracaoMonitoramentoPresenter } from './modules/motor-credito/integracao'
import { IntegracaoMonitoramentoFormPresenter } from './modules/motor-credito/integracao/form'
import ResultadoAnaliseVisaoCedentePresenter from './modules/motor-credito/integracao/resultado/resultado_analise_visao_cedente.presenter'
import { PFPresenter } from './modules/motor-credito/pf'
import { PJPresenter } from './modules/motor-credito/pj'
import { SerasaHistoryPresenter } from './modules/motor-credito/serasa-history'
import SerasaPresenter from './modules/motor-credito/serasa/serasa.presenter'
import { SerproPresenter } from './modules/motor-credito/serpro'
import { RDStationPresenter } from './modules/rd-station'
import { RestrictedPresenter } from './modules/restricted/Restricted.presenter'
import { TheActingPresenter } from './modules/the-acting'
import { TheConnectionPresenter } from './modules/the-connection'
import { TheConsumerMarketPresenter } from './modules/the-consumer-market'
import {
    TcmPresenterForFilterCatalogForm,
    TcmPresenterForFilterCatalogShare
} from './modules/the-consumer-market/tcm_presenter_filter_pane/tcm_filter_catalog_presenter'
import { TheMapPresenter } from './modules/the-map'
import { TheMapMarkDetailsPresenter } from './modules/the-map/mark_details/tm_md_details_presenter'
import { UserProfilePresenter } from './modules/user-profile'

let buildOnce = () => {
    CubeBuilder.build({
        overview: {
            presenter: Place.creator(OverviewPresenter, Places, 'overview')
        },
        theConnection: {
            presenter: Place.creator(TheConnectionPresenter, Places, 'theConnection')
        },
        theMap: {
            presenter: Place.creator(TheMapPresenter, Places, 'theMap'),

            markDetail: {
                presenter: Place.creator(TheMapMarkDetailsPresenter, Places, 'theMapMarkDetail')
            }
        },
        theActing: {
            presenter: Place.creator(TheActingPresenter, Places, 'theActing')
        },
        mercadoVet: {
            presenter: Place.creator(MercadoVetPresenter, Places, 'mercadoVet'),

            filterCatalogForm: {
                presenter: Place.creator(MvFilterCatalogFormPresenter, Places, 'mercadoVet_FilterCatalogForm')
            },

            filterCatalogShare: {
                presenter: Place.creator(MvFilterCatalogSharePresenter, Places, 'mercadoVet_FilterCatalogShare')
            }
        },
        analiseDesempenho: {
            presenter: Place.creator(AnaliseDesempenhoPresenter, Places, 'analiseDesempenho'),

            filterCatalogForm: {
                presenter: Place.creator(AdFilterCatalogFormPresenter, Places, 'analiseDesempenho_FilterCatalogForm')
            },

            filterCatalogShare: {
                presenter: Place.creator(AdFilterCatalogSharePresenter, Places, 'analiseDesempenho_FilterCatalogShare')
            }
        },
        theConsumerMarket: {
            presenter: Place.creator(TheConsumerMarketPresenter, Places, 'theConsumerMarket'),

            filterCatalogForm: {
                presenter: Place.creator(
                    TcmPresenterForFilterCatalogForm,
                    Places,
                    'theConsumerMarket_FilterCatalogForm'
                )
            },

            filterCatalogShare: {
                presenter: Place.creator(
                    TcmPresenterForFilterCatalogShare,
                    Places,
                    'theConsumerMarket_FilterCatalogShare'
                )
            }
        },
        rdStation: {
            presenter: Place.creator(RDStationPresenter, Places, 'rdStation')
        },
        userProfile: {
            presenter: Place.creator(UserProfilePresenter, Places, 'profile')
        },
        groupProfile: {
            presenter: Place.creator(GroupProfilePresenter, Places, 'groupProfile')
        },
        userManager: {
            presenter: Place.creator(UserManagerPresenter, Places, 'userManager'),

            form: {
                presenter: Place.creator(UserManagerFormPresenter, Places, 'userManagerForm')
            }
        },
        changePasswordForm: {
            presenter: Place.creator(UserChangePasswordFormPresenter, Places, 'userChangePasswordForm')
        },
        groupManager: {
            presenter: Place.creator(GroupManagerPresenter, Places, 'groupManager'),

            form: {
                presenter: Place.creator(GroupManagerFormPresenter, Places, 'groupManagerForm')
            }
        },
        configurations: {
            presenter: Place.creator(ConfigurationPresenter, Places, 'configurations')
        },
        accessAudit: {
            presenter: Place.creator(AccessAuditPresenter, Places, 'accessAudit')
        },
        billing: {
            presenter: Place.creator(BillingPresenter, Places, 'billing')
        },
        restricted: {
            presenter: Place.creator(RestrictedPresenter, Places, 'restricted')
        },

        // :: Motor de Crédito
        mcPj: {
            presenter: Place.creator(PJPresenter, Places, 'mcPj')
        },
        mcPf: {
            presenter: Place.creator(PFPresenter, Places, 'mcPf')
        },
        mcSerasa: {
            presenter: Place.creator(SerasaPresenter, Places, 'mcSerasa')
        },
        mcSerasaHistory: {
            presenter: Place.creator(SerasaHistoryPresenter, Places, 'mcSerasaHistory')
        },
        mcSerpro: {
            presenter: Place.creator(SerproPresenter, Places, 'mcSerpro')
        },
        mcGrupo: {
            presenter: Place.creator(GrupoPresenter, Places, 'mcGrupo'),

            grupoForm: {
                presenter: Place.creator(GrupoFormPresenter, Places, 'mcGrupoForm'),

                analiseSelect: {
                    presenter: Place.creator(AnaliseSelectPresenter, Places, 'mcAnaliseSelect')
                }
            }
        },
        mcAnalise: {
            presenter: Place.creator(AnalisePresenter, Places, 'mcAnalise'),

            analiseForm: {
                presenter: Place.creator(AnaliseFormPresenter, Places, 'mcAnaliseForm'),

                regraForm: {
                    presenter: Place.creator(RegraFormPresenter, Places, 'mcRegraForm'),

                    condicaoForm: {
                        presenter: Place.creator(CondicaoFormPresenter, Places, 'mcCondicaoForm')
                    }
                }
            }
        },
        mcMonitorados: {
            presenter: Place.creator(IntegracaoMonitoramentoPresenter, Places, 'mcIntegracaoMonitoramento'),

            borderoForm: {
                presenter: Place.creator(IntegracaoMonitoramentoFormPresenter, Places, 'mcIntegracaoMonitoramentoForm')
            },
            resultadoAnalise: {
                presenter: Place.creator(
                    ResultadoAnaliseVisaoCedentePresenter,
                    Places,
                    'mcResultadoAnaliseVisaoCedente'
                )
            }
        },
        mcBordero: {
            presenter: Place.creator(BorderoPresenter, Places, 'mcBordero'),

            borderoForm: {
                presenter: Place.creator(BorderoFormPresenter, Places, 'mcBorderoForm')
            },
            resultadoAnalise: {
                presenter: Place.creator(ResultadoAnalisePresenter, Places, 'mcResultadoAnalise')
            },
            statusProcessamento: {
                presenter: Place.creator(StatusProcessamentoPresenter, Places, 'mcStatusProcessamentoBordero')
            },
            resultadoDetalhadoAnalise: {
                presenter: Place.creator(ResultadoDetalhadoAnalisePresenter, Places, 'mcResultadoDetalhadoAnalise'),

                dialogResultadoDetalhadoAnalise: {
                    presenter: Place.creator(DialogoResultadoPresenter, Places, 'mcDialogoResultadoDetalhadoAnalise')
                }
            }
        }
    })

    buildOnce = NOOP_VOID
}

export function buildCube() {
    buildOnce()
    return Places
}
